<template>
  <div class='container-finalPart'>
    <div class='btn-option-print'>
      <div class='btn-print' @click='downloadPdf()'>
        <i class='el-icon-printer' />
        <p>IMPRIMIR EVALUACIÓN</p>
      </div>
      <div class='btn-exit'>
        <i class='el-icon-right' />
        <p>SALIR</p>
      </div>
    </div>
    <div>
      <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="false"
        :preview-modal="true"
        :paginate-elements-by-height="1400"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="letter"
        pdf-orientation="portrait"
        pdf-content-width="750px"
        @progress="onProgress($event)"
        @hasStartedGeneration="hasStartedGeneration()"
        @hasGenerated="hasGenerated($event)"
        ref="html2Pdf"
      >
        <pdf-content @domRendered='domrendered()' slot='pdf-content' />
      </vue-html2pdf>
    </div>
  </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf';
import PdfContent from './pdfPrint/pdfprint';

export default {
  data() {
    return {
      contentRendered: false,
      progress: 0,
      generatingPdf: false,
      pdfDownloaded: false,
    };
  },
  components: {
    VueHtml2pdf,
    PdfContent,
  },
  methods: {
    downloadPdf() {
      // if (!(this.validateControlValue())) return;

      this.$refs.html2Pdf.generatePdf();
    },
    validateControlValue() {
      if (this.controlValue.pdfQuality > 2) {
        alert('pdf-quality value should only be 0 - 2');
        this.controlValue.pdfQuality = 2;

        return false;
      }

      if (!this.controlValue.paginateElementsByHeight) {
        alert('paginate-elements-by-height value cannot be empty');
        this.controlValue.paginateElementsByHeight = 1400;

        return false;
      }

      const paperSizes = [
        'a0',
        'a1',
        'a2',
        'a3',
        'a4',
        'letter',
        'legal',
        'a5',
        'a6',
        'a7',
        'a8',
        'a9',
        'a10',
      ];

      if (!paperSizes.includes(this.controlValue.pdfFormat)) {
        alert(`pdf-format value should only be ${paperSizes}`);
        this.controlValue.pdfFormat = 'a4';

        return false;
      }

      if (!this.controlValue.pdfOrientation) {
        alert('pdf-orientation value cannot be empty');
        this.controlValue.pdfOrientation = 'portrait';

        return false;
      }

      if (!this.controlValue.pdfContentWidth) {
        alert('pdf-content-width value cannot be empty');
        this.controlValue.pdfContentWidth = '800px';

        return false;
      }

      return true;
    },

    onProgress(progress) {
      this.progress = progress;
      // console.log(`PDF generation progress: ${progress}%`);
    },
    startPagination() {
      // console.log('PDF has started pagination');
    },
    hasPaginated() {
      // console.log('PDF has been paginated');
    },
    hasDownloaded() {
      // console.log('PDF has downloaded yehey');
      this.pdfDownloaded = true;
      // console.log(blobPdf);
    },
    domrendered() {
      // console.log('Dom Has Rendered');
      this.contentRendered = true;
    },
    onBlobGenerate() {
      // console.log(blob);
    },
  },
};
</script>
<style lang='scss'>
.btn-option-print {
  margin: 100px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  div {
    display: flex;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    padding: 15px;
    width: 200px;
    margin-left: 20px;
    border-style: solid;
    border-width: 1px;
    border-color: #B8B8B8;
    border-radius: 20px;
    box-shadow: 3px 5px 6px rgb(216, 216, 216);

    i {
      font-size: 45px;
      color: #B8B8B8;
    }

    p {
      font-weight: 600;
      font-size: 15px;
      color: #B8B8B8;
    }
  }
  div:hover {
    animation: mymove 1s;
    cursor: pointer;
    border-color: #6a41bdca;
    p, i{
      animation: mymove 1s;
      color: #6a41bdca;
    }
  }
}
@keyframes mymove {
  from {color: #B8B8B8; border-color: #B8B8B8;}
  to {color: #6a41bdca; border-color: #6a41bdca;}
}
</style>
